export const vouchers = [
    {
        title: "Starbucks Gift Card",
        description: "Starbucks",
        contentDescription: "$25 gift card for premium coffee and beverages",
        value: "$25",
        points: 25,
        category: "food",
        isTrending: true,
        isFeatured: true
    },
    {
        title: "Amazon Shopping Voucher",
        description: "Amazon",
        contentDescription: "$50 voucher for unlimited shopping options",
        value: "$50",
        points: 50,
        category: "shopping",
        isTrending: true,
        isFeatured: true
    },
    {
        title: "Netflix Premium Subscription",
        description: "Netflix",
        contentDescription: "3 months of Premium streaming subscription",
        value: "$40",
        points: 40,
        category: "entertainment",
        isTrending: true,
        isFeatured: true
    },
    {
        title: "Spotify Premium Subscription",
        description: "Spotify",
        contentDescription: "6 months of ad-free music streaming",
        value: "$35",
        points: 35,
        category: "entertainment",
    },
    {
        title: "Grab Food Voucher",
        description: "Grab",
        contentDescription: "₱500 voucher for food delivery",
        value: "$10",
        points: 10,
        category: "food",
        isTrending: true,
    },
    {
        title: "Airbnb Travel Credit",
        description: "Airbnb",
        contentDescription: "$100 credit for your next adventure",
        value: "$100",
        points: 100,
        category: "travel",
        isFeatured: true
    },
    {
        title: "Zalora Fashion Voucher",
        description: "Zalora",
        contentDescription: "₱1000 voucher for fashion & lifestyle",
        value: "$20",
        category: "shopping",
        points: 20,
    },
    {
        title: "Spa & Wellness Package",
        description: "Zen Wellness",
        contentDescription: "Relaxing spa treatment for 2 hours",
        value: "$50",
        points: 50,
        category: "wellness",
    },
    {
        title: "McDonald's Meal Voucher",
        description: "McDonald's",
        contentDescription: "₱300 worth of meals and treats",
        value: "$6",
        points: 6,
        category: "food",
        isTrending: true,
    },{
        title: "Cinema Movie Tickets",
        description: "SM Cinema",
        contentDescription: "2 premium movie tickets",
        value: "$12",
        points: 12,
        category: "entertainment",
        isOutOfStock: true,
    },
    {
        title: "BookDepository Voucher",
        description: "BookDepository Voucher",
        contentDescription: "$30 voucher for books worldwide",
        value: "$30",
        points: 30,
        category: "shopping",
    },
    {
        title: "Fitness First Membership",
        description: "Fitness First",
        contentDescription: "1 month gym membership pass",
        value: "$45",
        points: 45,
        category: "wellness",
    },
];
